import { css } from "../../../../styled-system/css";
import { useAppSelector } from "../../../redux/hooks";
import { TextAreaField } from "../../fields/base/TextAreaField";

export function DevErrorDisplay({ error, userMessage }: { error?: unknown; userMessage?: string }) {
  const isStaffUser = useAppSelector((state) => state.user.is_staff);
  return (
    <div>
      {userMessage}
      {import.meta.env.PROD && !isStaffUser ? null : (
        <TextAreaField
          aria-label={"Error details"}
          className={css({
            height: "300px",
            overflow: "auto",
          })}
          value={JSON.stringify(error, null, 2)}
          isReadOnly
        />
      )}
    </div>
  );
}
